import { createAction } from '@reduxjs/toolkit';

// Phát khi room đang mở đổi (kể cả rời room): dữ liệu giá đã tải theo room cũ không còn đúng, các slice giá
// reset về ban đầu để component tải lại kèm X-Room-Id mới
export const roomPriceContextChanged = createAction('roomPriceContext/changed');
